import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { fetchFamilyFestCompanyAttendeesGridAsync } from './familyFestCompanyAttendeesGridThunk';
const initialState = {
    status: APIStatus.IDLE,
    items: [],
    totalCount: 0
};
const familyFestCompanyAttendeesGridSlice = createSlice({
    name: 'familyFestCompanyAttendeesGrid',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFamilyFestCompanyAttendeesGridAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(fetchFamilyFestCompanyAttendeesGridAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.items = action.payload.items;
            state.totalCount = action.payload.totalCount;
        })
            .addCase(fetchFamilyFestCompanyAttendeesGridAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default familyFestCompanyAttendeesGridSlice.reducer;
